import MetadataManagementRoute from '@/features/admin/metadata/components/MetadataManagementRoute.tsx';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/metadata')({
  component: MetadataManagementRoute,
});
